import axios from "axios";

export default {
  async create(formData) {
    return axios.post(`/document-contents`, formData);
  },
  async findOne({id}) {
    return axios.get(`/document-contents/${id}`);
  },
  async findAll() {
    return axios.get(`/document-contents`);
  },
  async delete({ id }) {
    return axios.delete(`/document-contents/${id}`);
  },
  async update(formData) {
    return axios.put(`/document-contents/${formData.id}`, formData);
  }
};
